var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJukeboxOfflineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.08,
    height: 19.264,
    viewBox: "0 0 24.08 19.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1476",
    "data-name": "Trac\\xE9 1476",
    d: "M-13495.2-5900.207a1.747,1.747,0,0,1-1.263-.542,1.742,1.742,0,0,1-.542-1.264v-15.649a1.722,1.722,0,0,1,.542-1.267,1.714,1.714,0,0,1,1.263-.542h20.47a1.743,1.743,0,0,1,1.267.542,1.751,1.751,0,0,1,.539,1.267v15.649a1.744,1.744,0,0,1-.539,1.264,1.749,1.749,0,0,1-1.267.542Zm11.442-7.073,4.546,4.546,1.413-1.416-5.962-5.962v-.586l-1.084-1.084v.589l-5.955-5.958-1.412,1.416,6.246,6.246a2.6,2.6,0,0,0-.5-.051,2.6,2.6,0,0,0-1.927.8,2.638,2.638,0,0,0-.782,1.911,2.645,2.645,0,0,0,.782,1.914,2.613,2.613,0,0,0,1.927.8,2.615,2.615,0,0,0,1.925-.8,2.661,2.661,0,0,0,.782-1.914v-.454Zm0-3.418v-2.693h3.252v-2.168h-4.336v3.777Z",
    transform: "translate(13497 5919.47)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJukeboxOfflineIcon);
export default __webpack_public_path__ + "static/media/jukebox-offline-icon.2434834991404c3cd0659d4770b56d7d.svg";
export { ForwardRef as ReactComponent };